import React, { useState } from "react";
import { Modal, Button } from "antd";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import Lottie from "lottie-react";
import validateAnimation from "../../../../assets/animations/validate.json";
import warningAnimation from "../../../../assets/animations/close.json";
import "../utils/validate.css";
import { activeMerchant, deactiveMerchant } from "../services/merchentApi";

const ManageMerchent = ({ modal, setModal, toggle, selectedMerchent, mode = "validate" }) => {
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const isValidateMode = mode === "validate";

  const handleAction = async () => {
    setIsLoadingSubmit(true);
    try {
      if (isValidateMode) {
        await activeMerchant(selectedMerchent?.id);
        toast.success("Le marchant a été validé avec succès");
      } else {
        await deactiveMerchant(selectedMerchent?.id);
        toast.success("Le marchant a été désactivé avec succès");
      }
      queryClient.invalidateQueries("merchents");
      setModal(false);
    } catch (error) {
      toast.error(`Erreur : ${error?.message || error}`);
    } finally {
      setIsLoadingSubmit(false);
    }
  };
  return (
    <Modal
      open={modal}
      onCancel={toggle}
      footer={null}
      centered
      width={600}
      className="modal-validate"
    >
      <div className="validate-modal-content">
        <h2 className="validate-title">
          {isValidateMode
            ? `Validation du marchant « ${selectedMerchent?.firstName + " " + selectedMerchent?.latstName} »`
            : `Désactivation du marchant « ${selectedMerchent?.firstName + " " + selectedMerchent?.lastName} »`}
        </h2>

        <div className="validate-animation">
          <Lottie
            animationData={isValidateMode ? validateAnimation : warningAnimation}
            style={{ height: 180 }}
            loop
          />
        </div>
        <div className="validate-description">
          {isValidateMode ? (
            <>
              <p>Êtes-vous sûr de vouloir activer ce marchant ?</p>
              <p>Cette action le rendra actif dans l’environnement de production.</p>
              <p><strong>{selectedMerchent?.firstName + " " + selectedMerchent?.lasttName}</strong> pourra désormais reprendre ses activités.</p>
            </>
          ) : (
            <>
              <p>Voulez-vous vraiment désactiver ce marchant ?</p>
              <p>Il ne pourra plus continuer ses activés ni se connecter à l'application.</p>
              <p><strong>{selectedMerchent?.firstName + " " + selectedMerchent?.larstName}</strong> sera marqué comme inactif.</p>
            </>
          )}
        </div>
        <div className="validate-footer">
          <Button onClick={() => setModal(false)} disabled={isLoadingSubmit}>
            Annuler
          </Button>
          <Button
            type={isValidateMode ? "success" : "danger"}
            danger
            onClick={handleAction}
            loading={isLoadingSubmit}
          >
            {isLoadingSubmit
              ? isValidateMode
                ? "Validation en cours..."
                : "Désactivation..."
              : isValidateMode
                ? "Valider"
                : "Désactiver"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ManageMerchent;
